export interface DownloadK8sAgentData extends Partial<K8sScriptData> {
  companyIdsWithKspm?: string[];
}

export interface K8sScriptData {
  csrToken: string;
  accessToken: string;
  gzServer: string;
  cnappServer: string;
  success: boolean;
}

export interface Company {
  _id: string;
  name: string;
}

export interface GetAvailableCompaniesResponse {
  data: Company[];
  count: number;
}

export const DownloadK8sEvents = {
  CompanyDropdownValidated: 'CompanyDropdownValidated',
  DownloadK8sPageOpened: 'DownloadK8sPageOpened',
};
